import { AuthenticationTicket } from '../../backend/model';

export class SithsAutoStartUtil {
  private static readonly BASE_URL = 'siths://';
  private static readonly AUTOSTARTTOKEN = 'autostarttoken';
  private static readonly MULTICARD = 'multicard';

  public static autoStart(authenticationTicket: AuthenticationTicket): void {
    let params = '';

    if (authenticationTicket?.autoStartToken != null) {
      params += this.addParam(params, this.AUTOSTARTTOKEN, authenticationTicket.autoStartToken);
    }

    if (authenticationTicket?.multicard) {
      params += this.addParam(params, this.MULTICARD, String(authenticationTicket.multicard));
    }

    window.location.href = this.BASE_URL + params;
  }

  private static addParam(currentParams: string, paramName: string, paramValue: string): string {
    return this.addParameterSymbol(currentParams) + paramName + '=' + paramValue;
  }

  private static addParameterSymbol(currentParams: string): string {
    if (currentParams && currentParams.length) {
      return '&';
    }

    return '?';
  }
}
